import Navbar from "../components/lib/Navbar";
import Footer from "../components/lib/Footer";
import HeroSection from "../components/landing-page/join-us/HeroSection";
import Advantages from "../components/landing-page/join-us/Advantages";
import Values from "../components/landing-page/join-us/Values";
import Openings from "../components/landing-page/join-us/Openings";
import Loader from "../components/lib/Loader";

const JoinUs = () => {
  return (
    <div>
      <div>
        <Loader />
      </div>
      <div>
        <Navbar />
      </div>
      <div>
        <HeroSection />
      </div>
      <div>
        <Advantages />
      </div>
      <div>
        <Values />
      </div>
      <div>
        <Openings />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default JoinUs;
